<template>
  <v-app>
    <v-container class="grey lighten-5">
      <v-row class="justify-center">
        <v-col class="col-12 col-md-10">
          <h2 class="text-center text-md-left primary--text ml-md-4">Pesquisa de profissionais</h2>
          <v-row>
            <v-col class="col-12 col-md-6">
              <v-text-field
                solo
                prepend-inner-icon="people"
                label="Pesquise pelo nome do Psicólogo"
                v-model="list_search.name"
                required
                background-color="#f7f1e4"
              ></v-text-field>
            </v-col>
            <v-col class="col-12 col-md-6">
              <v-autocomplete
                solo
                label="Pesquise por especialidade"
                :items="specialities"
                item-text="description"
                item-value="description"
                v-model="list_search.speciality"
                prepend-inner-icon="record_voice_over"
                hide-no-data
                clearable
                background-color="#f7f1e4"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="col-12 col-md-3">
              <span class="text-center text-md-left primary--text ml-md-4">Sexo:</span>
              <v-select
                prepend-inner-icon="person"
                hide-details
                solo
                flat
                label="Feminino, Masculino ou Não Definido"
                :items="list_gender"
                v-model="list_search.gender"
                background-color="#F7F7F7"
                color="primary"
              ></v-select>
            </v-col>
            <v-col class="col-12 col-md-3">
              <span class="text-center text-md-left primary--text ml-md-4">Moeda:</span>
              <v-select
                prepend-inner-icon="attach_money"
                hide-details
                solo
                flat
                label="Real ou Euro"
                :items="list_currency"
                v-model="list_search.currency"
                @change="getCurrency"
                background-color="#F7F7F7"
                color="primary"
              ></v-select>
            </v-col>
            <v-col class="col-12 col-md-3">
              <span class="text-center text-md-left primary--text ml-md-4">Valor máximo da Consulta:</span>
              <v-text-field
                solo
                flat
                prepend-inner-icon="eject"
                :label="labelMoney"
                v-model="list_search.money"
                background-color="#F7F7F7"
              ></v-text-field>
            </v-col>
            <v-col class="col-12 col-md-3">
              <v-btn
                color="secondary"
                height="70"
                width="100%"
                class="navbar-buttons white--text mt-md-3"
                @click="searchPsychologists"
                :loading="isLoading"
                :disabled="isLoading"
              >
                <v-icon color="primary" size="32" class="mr-2 white--text">search</v-icon>PESQUISAR
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="col-12">
              <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
                <p>Carregando...</p>
                <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
              </div>

              <v-row v-if="isPsy && !isLoading">
                <v-col class="col-12 col-md-3" v-for="user in psy" :key="user.id">
                  <CardPsy :name="user.name" :img="user.photo" :id="user.id" />
                </v-col>
                <v-pagination v-model="pageSearch" :length="lengthPage"></v-pagination>
              </v-row>

              <div v-if="notPsy && !isLoading" class="text-center">
                <p>
                  <v-icon x-large color="gray">sentiment_very_dissatisfied</v-icon>Ops! Nenhum psicologo encontrado.
                </p>
                <p>
                  Entre em contato com a nossa
                  <router-link to="help">equipe de suporte</router-link>para auxiliá-lo.
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';
import CardPsy from '../../components/CardPsy';

export default {
  components: {
    CardPsy,
  },

  data: () => ({
    cod: '',
    labelMoney: 'Até €90',
    list_gender: ['Masculino', 'Feminino', 'Não Definido'],
    list_currency: ['Euro', 'Real'],
    list_search: {
      name: '',
      gender: '',
      currency: '',
      money: '',
      speciality: '',
    },
    psy: [],
    isPsy: false,
    notPsy: false,
    specialities: [],
    page: 1,
    isLoading: false,
    pageSearch: 1,
    lengthPage: 1,
  }),
  created() {
    this.getSpecialities();
    if (this.$route.params.name) {
      this.list_search.name = this.$route.params.name;
      console.log(this.$route.params.name);
      this.searchPsychologists();
    }
  },
  watch: {
    pageSearch() {
      this.searchPsychologists();
    },
  },
  methods: {
    getCurrency(val) {
      if (val == 'Euro') {
        this.labelMoney = 'Até €90';
      } else {
        this.labelMoney = 'Até R$90';
      }
    },
    async searchPsychologists() {
      try {
        this.isLoading = true;
        this.psy = [];
        const {
          name, gender, currency, money, speciality,
        } = this.list_search;

        /**
         * Cria duas variaves para receber o valor,
         * e adepender do tipo moeda coloca o valor em uma das duas.
         */
        let br_value = '';
        let pt_value = '';
        if (currency == 'Real') {
          br_value = money;
        } else {
          pt_value = money;
        }

        const { data } = await http.get('/psychologists/', {
          params: {
            name,
            gender,
            br_value,
            pt_value,
            speciality,
            page: this.pageSearch,
          },
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        });

        if (data.results.length > 0) {
          this.lengthPage = Math.ceil(data.count / 10);
          this.psy = data.results;
          this.isPsy = true;
          this.notPsy = false;
        } else {
          this.isPsy = false;
          this.notPsy = true;
        }
        // console.log(this.psy);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    getSpecialities() {
      http
        .get('/specialities/', {
          params: {
            page: this.page,
          },
        })
        .then((res) => {
          for (const item of res.data.results) {
            this.specialities.push(item);
          }
          if (res.data.next != null) {
            this.page = this.page + 1;
            this.getSpecialities();
          }
        });
    },
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
  color: #f7f1e4;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

* >>> .v-text-field__slot .v-label,
* >>> .v-select__slot .v-label {
  color: #02a554;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
